import React from 'react'

import { FormControlLabel, Switch, SxProps, Tooltip } from '@mui/material'

import Iconify from '../Iconify/Iconify'

// ----------------------------------------------------------------------

type SwitchWithTooltipPropType = {
  value: boolean
  text: string
  onChange: () => void
  icon: string
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'default'
  iconColor?: string
  size?: number
  sx?: SxProps
}

const SwitchWithTooltip: React.FC<SwitchWithTooltipPropType> = ({
  value,
  onChange,
  text,
  icon,
  size = 25,
  color = 'primary',
  iconColor = 'primary.main',
  sx,
}) => (
  <Tooltip title={text}>
    <FormControlLabel
      control={
        <Switch
          size={size < 25 ? 'small' : 'medium'}
          checked={value}
          onChange={onChange}
          color={color}
          inputProps={{ 'aria-label': text }}
        />
      }
      labelPlacement={'start'}
      label={
        icon && <Iconify icon={icon} width={size} height={size} sx={{ color: iconColor, ...sx }} />
      }
    />
  </Tooltip>
)

export default SwitchWithTooltip
